import { ClipboardCheck, Wrench, PackageCheck, Route } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/primitives";

const STEPS = [
  { icon: ClipboardCheck, title: "Detailed Inspection" },
  { icon: Wrench, title: "Expert Service" },
  { icon: PackageCheck, title: "OEM / OES Spares" },
  { icon: Route, title: "Ready for More Miles" },
];

export default function CareFlow() {
  return (
    <section
      id="care"
      data-testid="care-section"
      className="bg-espresso py-20 text-ivory sm:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-10">
        <Reveal>
          <Eyebrow index="09">
            The Process
          </Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-display text-3xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Complete Care <span className="gold-text">at Every Step.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={0.15 + i * 0.1}>
              <div
                data-testid={`care-step-${i + 1}`}
                className="relative border-l border-gold/30 pl-6 lg:border-l-0 lg:border-t lg:pl-0 lg:pt-6"
              >
                <span className="gold-text font-display text-5xl font-black tracking-tighter">
                  0{i + 1}
                </span>
                <div className="mt-4 flex items-center gap-3">
                  <s.icon size={18} strokeWidth={1.5} className="text-gold" />
                  <span className="font-display text-sm font-bold uppercase tracking-[0.15em]">
                    {s.title}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
